module.exports = __webpack_public_path__ + "img/halfcut-bg-dark.0bf341ce.svg";